import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  constructor(private http: HttpClient) { }

  private apiUrl = environment.apiUrl;

  getAllTemplates() {
    return this.http.get(`${this.apiUrl}/templates`);
  }
  getAllTemplatesById(id: string) {
    return this.http.get(`${this.apiUrl}/templates/${id}`);
  }

  createTemplate(doc: any, templateId: string) {
    const formData = new FormData();

    Object.keys(doc).forEach(key => {
      const value = doc[key];

      if (value === null || value === undefined) {
        return;
      }

      if (value instanceof File) {
        formData.append(key, value);
      }
      else if (Array.isArray(value) || typeof value === 'object') {
        formData.append(key, JSON.stringify(value));
      }
      else {
        formData.append(key, value);
      }
    });
    if (templateId) {
      return this.http.patch(`${this.apiUrl}/templates/${templateId}`, formData);
    }
    return this.http.post(`${this.apiUrl}/templates`, formData);
  }

  deleteTemplate(id: string) {
    return this.http.delete(`${this.apiUrl}/templates/${id}`);
  }

  useTemplate(templateId: string) {
    return this.http.post(`${this.apiUrl}/templates/use`, { templateId });
  }
}
